import { gql } from '@apollo/client';

export const GET_STORE_BY_ID = gql`
  query store($id: ID!) {
    store(id: $id) {
      id
      name
      enableLocalComms
      merchantId
      merchantCode
      payStoreRefs {
        instore
      }
      checkoutOptions {
        enableTips
        tipOptions {
          name
          value
        }
      }
    }
  }
`;
